import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import Icon from '../../components/icons';
import { URLS } from '../../_config';
import General from './_components/general';
import Warranty from './_components/warranty';
import Maintenance from './_components/maintenance';
import PartsList from './_components/partsList';
import Accounting from './_components/accounting';
import Notes from './_components/notes';
import Attachments from './_components/attachments';
import { useParams } from 'react-router-dom';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Drawer from '../../components/Drawer';
import Button from '../../components/elements/button';
import CreateAssets from './_components/createAssets';
import { Dropdown, Menu } from '../../components/Dropdown';

const AssetsDetails: React.FC = () => {
    const [tab, setTab] = useState('general');
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
    const [asset, setAsset] = useState<any>(null)

    const getAssetsList = (assetID: any) => {
        const payload = {
            assetID: assetID
        }
        assetsAPI.getAssetsList(payload, (data: any) => {
            setAsset(data.assetList[0]);
        }, (error: any) => { });
    };

    useEffect(() => {
        if (params.id) {
            getAssetsList(params.id);
        }
    }, [params]);

    return (
        <Layout>
            <Header title={asset?.name} back={URLS.ASSETS}>
                <Header.Right>
                    <Drawer _ref={addNewAssetRef} onClose={() => { }} outsideClose={false}>
                        <Drawer.Button>
                            <Button theme='light'>Edit</Button>
                        </Drawer.Button>
                        <Drawer.Content title={asset ? 'Edit Assets' : 'Create New Assets'} className='!w-[39.563rem]'>
                            <CreateAssets editData={asset} onCreate={() => {
                                addNewAssetRef.current.close();
                            }} onCancel={() => {
                                addNewAssetRef.current.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Button>Create Work Order</Button>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary' className='h-[2.25rem]'><Icon name='threedote' size={1.25} className='' /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            {/* <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>
                            <Menu onClick={onBulkPrintQR}>Print QR Code</Menu> */}
                        </Dropdown.Content>
                    </Dropdown>

                    
                </Header.Right>

               
            </Header>

            <div className='px-5 border-b border-gray-200 h-[3.75rem] flex items-center gap-[2.188rem] text-gray-600 text-[0.938rem] font-medium'>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'general' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('general')}>
                    General
                </button>
                <button className='hover:text-black' onClick={() => {
                    // setTab('warranty')

                }}>
                    Warranty
                </button>
                <button className='hover:text-black' onClick={() => {
                    // setTab('maintenance')

                }}>
                    Maintenance
                </button>
                <button className='hover:text-black' onClick={() => {
                    // setTab('parts-list')

                }}>
                    Parts List
                </button>
                <button className='hover:text-black' onClick={() => {
                    // setTab('accounting')

                }}>
                    Accounting
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'notes' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('notes')}>
                    Notes
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'attachments' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('attachments')}>
                    Attachments
                </button>
            </div>
            <div className='px-5'>
                {tab === 'general' && <General />}
                {tab === 'warranty' && <Warranty />}
                {tab === 'maintenance' && <Maintenance />}
                {tab === 'parts-list' && <PartsList />}
                {tab === 'accounting' && <Accounting />}
                {tab === 'notes' && <Notes />}
                {tab === 'attachments' && <Attachments />}
            </div>
        </Layout>
    );
};

export default AssetsDetails;